import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Star } from './icons';
import { StyledContainer, StyledDescription, StyledStar, StyledStarRating, } from './grade.styles';
/**
 * A star rating display with optional description.
 */
export const Grade = ({ grade, maxGrade = 5, description, size = 'medium', className, translations, }) => {
    const themeContext = useContext(ThemeContext);
    const stars = Array(grade).fill(_jsx(Star, { fill: themeContext?.ColorThemeAccent2 }));
    const ariaLabel = `${grade} ${translations.outOf} ${maxGrade} ${translations.stars}`;
    return (_jsxs(StyledContainer, { className: className, children: [_jsx(StyledStarRating, { "data-testid": "star-rating", "aria-label": ariaLabel, children: stars.map((icon, index) => (_jsx(StyledStar, { size: size, "aria-hidden": true, children: icon }, index))) }), description && (_jsx(StyledDescription, { size: size, children: description }))] }));
};
//# sourceMappingURL=grade.js.map